<template>
  <a-layout-header class="header">
    <div class="header-contanier">
      <div class="meeting-header-left">
        <div class="meeting-name">
          <div class="meeting-logo"><img src="@/assets/images/logo.png" /></div>
          <div class="meeting-title" :title="meetingInfo.name">
            {{ meetingInfo.name }}
          </div>
        </div>
        <div class="meeting-guest-passwd">
          参会人密码: {{ meetingInfo.partyPassword }}
        </div>
      </div>
      <div v-show="!meetingEnd" class="meeting-router">
        <router-link
          :to="{ name: MONITOR_PAGE }"
          tag="span"
          exact-active-class="router-selected"
          >参会列表</router-link
        >
        <router-link
          :to="{ name: QUESTION_PAGE }"
          tag="span"
          exact-active-class="router-selected"
          >问答</router-link
        >
      </div>
      <div v-show="!meetingEnd" class="meeting-setting-contanier">
        <div class="meeting-time">
          {{ nowTime }}
        </div>
        <div class="meeting-setting">
          <svg-icon icon-class="setting" />
          <span class="meeting-setting-text">{{
            $t("components.header.meeting-setting")
          }}</span>
          <div class="meeting-setting-plan">
            <div class="meeting-setting-plan-title">
              解除静音
            </div>
            <a-radio-group
              :disabled="disabledRadio"
              v-model="meetingGuestMuteOverrideEnable"
            >
              <div class="meeting-setting-plan-checkbox">
                <a-radio
                  @click="handleGuestEnable"
                  :value="true"
                  :disabled="!meetingIsStart"
                >
                  允许参会人自己解除
                </a-radio>
              </div>
              <div class="meeting-setting-plan-checkbox">
                <a-radio
                  @click="handleChairmanEnable"
                  :value="false"
                  :disabled="!meetingIsStart"
                >
                  仅主持人才能解除
                </a-radio>
              </div>
            </a-radio-group>
          </div>
        </div>
      </div>
    </div>
  </a-layout-header>
</template>

<script>
import {
  confUpdateGuestMuteOverrideEnable,
  confUpdateGuestMuteOverrideDisable
} from "@/services/conf";

import { MONITOR_PAGE, QUESTION_PAGE } from "@/router/index";

import { mapState, mapGetters } from "vuex";

import { startTime } from "@/utils/time";

import { getCurrentTime } from "@/services/conf";

import { custConnecting } from "@/model/conf/model";

import moment from "moment";

export default {
  startTimeInterval: null,
  computed: {
    ...mapState(["meetingEnd"]),
    ...mapGetters([
      "meetingInfo",
      "meetingIsStart",
      "meetingGuestMuteOverrideEnable",
      "onlinePartyListInfo",
      "offlinePartyListInfo"
    ])
  },
  data() {
    return {
      MONITOR_PAGE,
      QUESTION_PAGE,
      disabledRadio: false,
      guestMute: true,
      nowTime: "00:00:00",
      startCountTime: false
    };
  },
  mounted() {
    this.guestMute = this.meetingGuestMuteOverrideEnable;
    // this.calculateStartTime();
    this.$on("confStartTime", () => {
      this.confStartTime();
    });
    this.$on("meeting-end", () => {
      this.clearStartTimeInterval();
    });
  },
  beforeDestroy() {
    this.clearStartTimeInterval();
  },
  methods: {
    confStartTime() {
      if (!this.startCountTime) {
        this.startCountTime = true;
        // 获取服务器时间
        getCurrentTime()
          .then(result => {
            this.calculateStartTime(result.data.Time);
          })
          .catch(error => {
            console.log(error);
            this.startCountTime = false;
          });
      }
    },
    clearStartTimeInterval() {
      clearInterval(this.startTimeInterval);
    },
    getConfStartTime() {
      let startTime = Number.MAX_VALUE;
      // console.log("init startTime:" + startTime);
      // console.log("firstJoinTime: " + this.meetingInfo.firstJoinTime);
      if (this.meetingInfo.firstJoinTime) {
        startTime = this.meetingInfo.firstJoinTime;
      } else {
        this.onlinePartyListInfo.forEach(party => {
          if (party.connectTime > 0 && party.connectTime < startTime) {
            startTime = party.connectTime;
          }
        });
        this.offlinePartyListInfo.forEach(party => {
          if (
            party.connectTime > 0 &&
            party.connectTime < startTime &&
            custConnecting(party.status)
          ) {
            startTime = party.connectTime;
          }
        });
      }

      return startTime;
    },
    calculateStartTime(serverTime) {
      let startSeconds = serverTime * 1000 - this.getConfStartTime();
      // console.log("serverTime:" + serverTime);
      // console.log("getConfStartTime:" + this.getConfStartTime());
      if (startSeconds < 0) {
        console.log("serverTime:" + serverTime);
        console.log("getConfStartTime:" + this.getConfStartTime());
        console.log("开始时间差值为负数，规避问题时间设为0");
        startSeconds = 0;
      }
      let localStartTime = parseInt(moment().format("x")) - startSeconds;

      if (this.startTimeInterval) {
        this.clearStartTimeInterval();
      }
      this.startTimeInterval = setInterval(() => {
        const timeDiff = parseInt(moment().format("x")) - localStartTime;
        if (timeDiff > 0) {
          this.nowTime = startTime(parseInt(timeDiff / 1000));
        } else {
          this.nowTime = "00:00:00";
        }
      }, 1000);
    },
    handleGuestEnable() {
      if (!this.meetingGuestMuteOverrideEnable) {
        this.disabledRadio = true;
        confUpdateGuestMuteOverrideEnable()
          .then(() => {
            this.disabledRadio = false;
          })
          .catch(error => {
            this.$message.error(`修改解除静音状态失败，请稍后再试`);
            this.disabledRadio = false;
            console.log(error);
          });
      }
    },
    handleChairmanEnable() {
      if (this.meetingGuestMuteOverrideEnable) {
        this.disabledRadio = true;
        confUpdateGuestMuteOverrideDisable()
          .then(() => {
            this.disabledRadio = false;
          })
          .catch(error => {
            this.$message.error(`修改解除静音状态失败，请稍后再试`);
            this.disabledRadio = false;
            console.log(error);
          });
      }
    },
    handleGuestMuteChange() {
      this.disabledRadio = true;
      if (this.meetingGuestMuteOverrideEnable) {
        confUpdateGuestMuteOverrideDisable()
          .then(() => {
            this.disabledRadio = false;
          })
          .catch(error => {
            this.$message.error(`修改解除静音状态失败，请稍后再试`);
            this.disabledRadio = false;
            console.log(error);
          });
      } else {
        confUpdateGuestMuteOverrideEnable()
          .then(() => {
            this.disabledRadio = false;
          })
          .catch(error => {
            this.$message.error(`修改解除静音状态失败，请稍后再试`);
            this.disabledRadio = false;
            console.log(error);
          });
      }
    }
  }
};
</script>

<style lang="less">
.header {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #ffffff !important;
  display: flex;
  justify-content: center;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.7);
  // box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  position: relative;
  .header-contanier {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    .meeting-setting-contanier {
      flex: 6;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .meeting-time {
        margin-right: 20px;
        font-size: 14px;
        color: #333333;
        letter-spacing: -0.15px;
        font-family: "Helvetica Neue";
      }
    }
    .meeting-router {
      width: 200px;
      flex: 2;
      display: flex;
      justify-content: space-around;
      span {
        cursor: pointer;
      }
      .router-selected {
        color: #417ff9;
        position: relative;
        /* border-bottom: 3px solid #417ff9; */
        &::after {
          content: "";
          width: 80%;
          height: 3px;
          bottom: 0;
          border-bottom: 3px solid #4f8bff;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          -webkit-transform: translateX(-50%);
        }
      }
    }
    .meeting-header-left {
      flex: 6;
      color: #333333;
      text-align: left;
      display: flex;
      font-size: 16px;
      letter-spacing: -0.18px;
      overflow: hidden;
      .meeting-name {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        .meeting-logo {
          display: inline;
          img {
            width: 56px;
            height: 27px;
          }
          margin-right: 20px;
          position: relative;
          &::after {
            content: "";
            width: 1px;
            height: 20px;
            right: -10px;
            border-right: 1px solid #d8d8d8;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            // -webkit-transform: translateY(-50%);
          }
        }
        .meeting-title {
          display: inline;
        }
        .setting {
          margin-left: 4px;
          margin-right: 24px;
        }
      }
      .meeting-guest-passwd {
        flex-shrink: 0;
        margin-left: 23px;
        text-align: right;
      }
    }
  }

  .meeting-setting {
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
  }
  .meeting-setting-text {
    margin-left: 4px;
    // margin-right: 32px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.7);
  }
  .online-service {
    margin-left: 4px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.7);
  }
  .meeting-setting-plan {
    display: none;
    position: absolute;
    bottom: -125px;
    right: 30px;
    width: 238px;
    height: 128px;
    border-radius: 4px;
    border: solid 1px #e5e5e5;
    background-color: #ffffff;
    z-index: 10;
    text-align: left;
    padding: 10px 0 0 25px;
    line-height: 18px;
  }
  .meeting-setting:hover .meeting-setting-plan {
    display: block;
  }

  .meeting-setting-plan:before {
    position: absolute;
    display: inline-block;
    border-width: 7px;
    border-style: solid;
    border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent;
    right: 25px;
    top: -11%;
    content: "";
    z-index: 10;
  }
  .meeting-setting-plan:after {
    position: absolute;
    display: inline-block;
    border-width: 7px; /*与before的三角形重叠差1px，和元素边框是边框宽度一致*/
    border-style: solid;
    border-color: transparent transparent #fff transparent; /*边框颜色（小角的填充色）要与整体元素背景一致*/
    right: 25px;
    top: -10%;
    content: "";
    z-index: 10;
  }
  .meeting-setting:hover .meeting-setting-plan {
    display: block;
  }
  .meeting-setting-plan-title {
    font-size: 13px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 18px;
  }
  .meeting-setting-plan-checkbox {
    color: #333333;
    margin-bottom: 14px;
  }
  .meeting-setting-plan-checkbox span {
    font-size: 13px;
  }
  .meeting-setting-plan-checkbox .ant-checkbox-inner {
    border-radius: 50%;
  }
}
</style>
